import script from "./ProjectUdcItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectUdcItem.vue?vue&type=script&setup=true&lang=js"

import "./ProjectUdcItem.vue?vue&type=style&index=0&id=6a06d4cc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a06d4cc"]])

export default __exports__